import { render, staticRenderFns } from "./ExtraordinaryChangeSidebar.vue?vue&type=template&id=a86a241a"
import script from "./ExtraordinaryChangeSidebar.vue?vue&type=script&lang=js"
export * from "./ExtraordinaryChangeSidebar.vue?vue&type=script&lang=js"
import style0 from "./ExtraordinaryChangeSidebar.vue?vue&type=style&index=0&id=a86a241a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports